"use client";

import CampusHours from "@/app/_components/CampusHours";
import InfoCard from "@/app/_components/InfoCard";
import {useCampusContext} from "@/app/_components/contexts/CampusCookieContext";
import InfoCardType from "@/app/types/InfoCard";

type ContactUsInfoCardProps = {
	infoCardValues: {
		withCookieCampus?: InfoCardType;
		withoutCookieCampus?: InfoCardType;
	};
};

const ContactUsInfoCard: React.FC<ContactUsInfoCardProps> = ({
	infoCardValues: {withCookieCampus, withoutCookieCampus},
}) => {
	const {campus} = useCampusContext();
	if (!campus) {
		return (
			withoutCookieCampus && (
				<InfoCard
					data={withoutCookieCampus}
					className="flex-1 items-start border-midtone-blue lg:flex-initial"
				/>
			)
		);
	}

	if (!campus.dropInHours) {
		return null;
	}

	return (
		withCookieCampus && (
			<InfoCard
				data={withCookieCampus}
				className="flex-1 items-start border-gray-500 lg:flex-initial"
			>
				<CampusHours key="hours" hours={campus.dropInHours} />)
			</InfoCard>
		)
	);
};

export default ContactUsInfoCard;
